import { GifOverlayProps, Video } from '@giphy/react-components'
import React, { createContext, useContext, useEffect, useState } from 'react'
import VideoPlayerAnalytics, { quartileOptions } from 'shared/components/video-player/analytics'
import styled from 'styled-components'
import Volume from './volume'

const VideoContainer = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    height: 100%;
    width: 100%;
`

const VideoStyled = styled(Video)<{ isReady: boolean }>`
    height: 100%;
    object-fit: contain;
    background: ${props => (props.isReady ? 'black' : 'transparent')};
`

type VideoOverlayContextProps = {
    onStartHover?: (gifId: string) => void
    onFinishHover?: (gifId: string) => void
    onFinishVolumeIconAnimation?: () => void
    finishVolumeIconAnimation?: boolean
}
export const VideoOverlayContext = createContext({} as VideoOverlayContextProps)

const VideoOverlay = ({
    gif,
    width,
    height,
    isHovered,
    volumeSize,
}: GifOverlayProps & { width: number; height?: number; volumeSize?: number }) => {
    // TODO useLocalStorage here? to save the user's state?
    const [muted, setMuted] = useState<boolean | undefined>(undefined)
    const [mutedByBrowser, setMutedByBrowser] = useState(true)
    const [isReady, setIsReady] = useState(false)
    const { onStartHover, onFinishHover } = useContext(VideoOverlayContext)

    const events: VideoPlayerAnalytics = new VideoPlayerAnalytics(gif.id)
    const toggleMute = () => {
        events.onMute(!muted)
        if (mutedByBrowser) {
            setMutedByBrowser(false)
            setMuted(false)
        } else {
            setMuted(!muted)
        }
    }

    useEffect(() => {
        if (isHovered) {
            onStartHover?.(gif.id.toString())
        } else {
            setIsReady(false)
            onFinishHover?.(gif.id.toString())
        }
    }, [isHovered])

    if (!isHovered) {
        return <Volume muted isHovered={false} volumeSize={volumeSize} />
    }

    return (
        <VideoContainer>
            <VideoStyled
                gif={gif}
                height={height}
                key={gif.id}
                loop
                muted={muted}
                width={width}
                isReady={isReady}
                onFirstPlay={() => events.onPlay?.()}
                onTimeUpdate={time => {
                    if (time > 0) {
                        setIsReady(true)
                    }
                }}
                onMuted={(muted: boolean) => setMutedByBrowser(muted)}
                onQuartile={(qt: quartileOptions) => events.onQuartile?.(qt)}
                onEnded={() => events?.onEnded?.()}
            />
            <Volume toggleMute={toggleMute} muted={muted || mutedByBrowser} isHovered={true} volumeSize={volumeSize} />
        </VideoContainer>
    )
}
export default VideoOverlay
